// export const BASE_URL = "https://centerts.net/ts/admin2/";
export const BASE_URL = "https://centerts.net/new_app/admin/"
export const SECOND_URL="https://centerts.net/new_app";
